(function () {
  if (window.__imageDialogInit) return;
  window.__imageDialogInit = true;

  var openDialog = null;

  function getOverlay(dialog) {
    var group = dialog.closest('.js-image-dialog');
    return group ? group.querySelector('.js-image-dialog-overlay') : null;
  }

  function open(dialog) {
    if (!dialog) return;
    var overlay = getOverlay(dialog);
    dialog.classList.add('is-visible');
    if (overlay) overlay.classList.add('is-visible');
    openDialog = dialog;
  }

  function close(dialog) {
    if (!dialog) return;
    var overlay = getOverlay(dialog);
    dialog.classList.remove('is-visible');
    if (overlay) overlay.classList.remove('is-visible');
    if (openDialog === dialog) openDialog = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-image-dialog-target]');
    if (trigger) {
      event.preventDefault();
      open(document.getElementById(trigger.getAttribute('data-image-dialog-target')));
      return;
    }

    if (event.target.closest('.js-image-dialog-close')) {
      event.preventDefault();
      close(event.target.closest('.image-dialog'));
      return;
    }

    if (event.target.classList.contains('js-image-dialog-overlay')) {
      var group = event.target.closest('.js-image-dialog');
      close(group ? group.querySelector('.image-dialog') : null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openDialog) {
      close(openDialog);
    }
  });
})();
